import axios from "axios";
import { getLs, baseUrl } from ".";

import { toast } from "react-hot-toast";

axios.defaults.baseURL = `${baseUrl}`;
axios.defaults.headers.common["Api-Token"] = getLs("coa_api") || "";
axios.defaults.headers.common["X-Requested-With"] = `XMLHttpRequest`;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    toast.error(error.message || "Something went wrong..", { duration: 40000 });
    //console.log(error);
    // whatever you want to do with the error
    throw error;
  }
);
/*
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    console.log(error);
    //toast.error(error);
    return Promise.reject(error);
  }
);*/

const Api = axios.create();

export default Api;
